import { css } from 'styled-system/css';



export const floatQuickBetStyle = {
	container: css({
		base: {
			position: 'fixed',
			bottom: '0',
			width: '100%',
			flex: 0,
			zIndex: 'var(--betslip-zindex)',
			minH: 'auto',
			p: '0',
			_ltr: {
				left: '0',
			},
			_rtl: {
				right: '0',
			},
		},
		_mars: {
			// 若為single match , fixed 底部
			'&[data-float="true"]': {
				bottom: 'var(--appbar-height)',
				zIndex: 'var(--appbar-zindex)',
				md: {
					bottom: 0,
				},
			},
		}
	}),
	breakpointTrans: css({
		base: {
			md: {
				_ltr: {
					left: '50%',
					transform: 'translateX(calc( (-50% + ((240px - 12px) / 2))))',
				},
				_rtl: {
					right: '50%',
					transform: 'translateX(calc( (50% - ((240px - 12px) / 2))))',
				},
			},

			lg: {
				_ltr: {
					transform: 'translateX(calc( (-50% + (240px / 2))))',
				},
				_rtl: {
					transform: 'translateX(calc( (50% - (240px / 2))))',
				},
			},

			lgx: {
				_ltr: {
					transform: 'translateX(calc( (-50% - ((383px - 240px) / 2))))',
				},
				_rtl: {
					transform: 'translateX(calc( (50% + ((383px - 240px) / 2))))',
				},
			}
		}
	}),
	content: css({
		'--galaxy-content-bg': { base: 'var(--lv2-100)', _dark: 'var(--s600)' },
		base: {
			ml: 'auto',
			mr: 'auto',
			display: 'flex',
			alignItems: 'center',
			w: '100%',
			maxW: '360px',
			minH: '36px',
			px: '6px',
			borderRadius: '6px 6px 0 0',
			bgColor: 'var(--galaxy-content-bg)',
			boxShadow: '0px -6px 6px 0px rgba(0, 0, 0, 0.12)',
			backdropFilter: 'blur(10px)',
			_active: {
				bgColor: 'var(--quickbet)'
			},
			_mdBelow: {
				maxW: 'none'
			},
			transition: 'max 2s ease-in-out',
			'&[data-active=false]': {
				w: 'auto',
				_dark: {
					'& .title': {
						color: 'var(--lv1-100)'
					}
				},
				_mdBelow: {
					_ltr: {
						ml: '0',
					},
					_rtl: {
						mr: '0',
					},
				}
			},
		},
		_galaxy: {
			'&[data-active=false]': {
				position: 'fixed',
				bottom: '20px',
				zIndex: 'var(--betslip-zindex)',
				borderRadius: '24px',
				border: '1px solid var(--border-primary-500)',
				bgColor: 'var(--background-neutral-100-300)',
				boxShadow: '0px 0px 20px 0px var(--shadow-utility-constant-black-30-54)',
				backdropFilter: 'blur(10px)',
				left: '50%',
				transform: 'translateX(-50%)',
			}
		},
	}),
	title: css({
		base: {
			fontSize: 'var(--font-size-md)',
			fontWeight: 700,
			color: 'rgba(0, 0, 0, 70%)',
		},
	}),
	stake: css({
		base: {
			display: 'flex',
			alignItems: 'center',
			cursor: 'pointer',
			color: 'rgba(0, 0, 0, 70%)',
			h: '23px',
			'& .icon': {
				w: '12px',
				h: '12px',
				ml: '3px',
			}
		}
	}),
	availableFunds: css({
		base: {
			fontSize: '12px',
			fontWeight: '500',
			lineHeight: '15px',
			textAlign: 'right',
			color: 'rgba(0, 0, 0, 70%)',
			ml: 'auto',
			'& .bCredit': {
				fontWeight: '700',
			}
		}
	}),

	pushAside: css({
		base: {
			lg: {
				_ltr: {
					left: '50%',
					transform: 'translateX(calc( (-50% + (240px / 2))))',
				},
				_rtl: {
					right: '50%',
					transform: 'translateX(calc( (50% + (240px / 2))))',
				}
			},
		}
	})
}